// ***************************************
// Definition of game token SkipReplayAnimation
// ***************************************
import { tbGame } from "../engine/tbGame";
import { ComponentSpine } from "../framework/components/ComponentSpine";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfGraphics } from "../framework/tgfGraphics";
import { explosion_transition } from "./AssetDefinitions/SpineDefinitions";
// The constructor for the SkipReplayAnimation game token. 
export var SkipReplayAnimation = function (callback) {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.finished = false;
    this.delay = 0;
    this.callback = callback;
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
SkipReplayAnimation.prototype.handleAdd = function () {
    "use strict";
    var self = this;
    this.dialog = new DialogBase({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.spine = new ComponentSpine({
        spineAnimation: explosion_transition,
        animationClip: "explosion_transition_animation",
        repeat: false,
        onComplete: function () {
            self.finished = true;
        }
    });
    this.dialog.addComponent(this.spine);
    this.dialog.show();
};
// handleRemove is called when the token is removed from the game.
SkipReplayAnimation.prototype.handleRemove = function () {
    "use strict";
    if (this.callback) {
        this.callback();
    }
};
// handleBeginStep is called each step before processing other events.
SkipReplayAnimation.prototype.handleBeginStep = function (timePassed) {
    "use strict";
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
SkipReplayAnimation.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
SkipReplayAnimation.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
SkipReplayAnimation.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
SkipReplayAnimation.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
SkipReplayAnimation.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (!this.finished)
        return;
    if (this.finished && this.delay <= 0) {
        this.dialog.hide();
        this.dialog.free();
        tbGame.removeToken(this);
        this.finished = false;
    }
    else {
        this.delay -= timePassed;
    }
};
// handleDraw is called at the end of a step to draw the token.
SkipReplayAnimation.prototype.handleDraw = function () {
    "use strict";
};
